import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaitopunecab() {



const cardData = {
  keyword: " Navi Mumbai to Pune Cab",

headingDescription: "Velocity Cab provides reliable and comfortable Navi Mumbai to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Navi Mumbai to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Navi Mumbai to Pune cab travel.",

topPlaces: [
 
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a famous hill fortress located on the outskirts of Pune, offering panoramic views of the surrounding Sahyadri hills. Travelers from Navi Mumbai by cab can enjoy trekking, photography, and historical exploration. The fort has several gates, bastions, and water reservoirs, and local vendors offer traditional snacks like 'pithla bhakri' at the summit. The site is ideal for outdoor enthusiasts, history lovers, and families seeking a day trip combining adventure, culture, and scenic landscapes."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered temples, dedicated to Lord Ganesha. Visitors traveling from Navi Mumbai by cab often attend daily rituals, participate in festive events, and enjoy the temple’s intricate carvings and architecture. The temple also hosts cultural programs and is surrounded by bustling markets offering sweets, religious items, and souvenirs. Travelers can spend time exploring the local traditions, experiencing spiritual blessings, and capturing photographs of the vibrant temple surroundings."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, situated in the heart of Pune. Travelers from Navi Mumbai can explore its unique carvings, rock-cut architecture, and serene atmosphere. The site offers a peaceful escape from the busy city, ideal for meditation, photography, and learning about ancient Indian temple design. Visitors can also observe locals performing daily prayers and rituals, making it a spiritual and culturally enriching experience."
  },
   {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Travelers using a Navi Mumbai to Pune cab can explore its grand gates, intricate architecture, and extensive gardens. The site also hosts light and sound shows in the evening that narrate its rich history. Visitors can enjoy guided tours, take photographs of its majestic ruins, and learn about the Maratha Empire’s heritage, making it a cultural and historical experience that lasts several hours."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is one of Pune’s most significant landmarks, known for its connection to Mahatma Gandhi and India’s freedom movement. Travelers arriving from Navi Mumbai by cab can explore its elegant colonial architecture, lush gardens, and the Gandhi museum. The palace also serves as a center for educational tours, cultural events, and quiet reflection. Visitors can stroll along the manicured lawns, photograph the heritage structure, and gain insight into India’s independence struggle while enjoying a peaceful ambiance."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum houses an extensive collection of Indian artifacts, including sculptures, musical instruments, traditional tools, and decorative items. Travelers from Navi Mumbai by cab can explore the museum’s galleries to gain insight into India’s artistic and cultural heritage. The museum also hosts temporary exhibitions, guided tours, and interactive learning sessions. Visitors can appreciate the craftsmanship of historic artifacts while enjoying a leisurely cultural exploration of Pune’s heritage."
  },
  {
    title: "Parvati Hill Temple",
    description: "Parvati Hill Temple is a heritage site in Pune offering panoramic views of the city and a glimpse into local history. Travelers using a Navi Mumbai to Pune cab can climb the hill’s steps to visit the historic temples, observe old water tanks, and enjoy scenic photography. The hill also features gardens and viewpoints perfect for relaxation. Visitors can combine spirituality, history, and nature in one visit, making it a popular spot for both tourists and locals."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a serene water reservoir near Pune, surrounded by scenic hills and greenery. Travelers from Navi Mumbai by cab can enjoy relaxing walks along the embankment, photography, and peaceful sunset views. The site is also popular for picnics, boating activities, and casual outings with family or friends. Visitors can explore the natural surroundings, capture panoramic landscapes, and enjoy a quiet retreat from the bustling city environment."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also called Pu La Deshpande Garden, is a beautifully landscaped Japanese-style garden. Travelers arriving from Navi Mumbai by cab can enjoy strolling through the carefully designed pathways, manicured lawns, and lotus ponds. The garden provides a serene escape for relaxation, photography, and meditation. Visitors can also observe koi fish, bonsai trees, and seasonal flowers, making it a peaceful destination for families, couples, and solo travelers alike."
  },
  {
    title: "Lal Mahal",
    description: "Lal Mahal is a historic palace in Pune associated with the childhood of Chhatrapati Shivaji Maharaj. Travelers from Navi Mumbai by cab can explore its reconstructed interiors, exhibits, and gardens that highlight Maratha history. The site also offers guided tours and informative plaques about Shivaji’s life and achievements. Visitors can immerse themselves in history, enjoy photography, and experience Pune’s rich cultural heritage in a single visit."
  }
],



services: [
{
name: "Navi Mumbai to Pune Taxi",
description: "Navi Mumbai to Pune taxi service offers reliable and comfortable intercity transportation between Navi Mumbai and Pune city through the Mumbai–Pune Expressway. Well-maintained vehicles such as sedan, Ertiga, and Innova ensure smooth highway travel for passengers. Professional drivers provide punctual pickup services from homes, offices, railway stations, hotels, and airport terminals across Navi Mumbai including Vashi, Airoli, Belapur, Nerul, and Kharghar. This taxi service is ideal for business travel, airport transfers, corporate trips, and family journeys. Air-conditioned vehicles provide comfortable seating for long-distance travel. Flexible booking options allow passengers to reserve rides easily with convenient pickup and drop locations."
},
{
name: "Navi Mumbai to Pune Taxi Fare",
description: "Navi Mumbai to Pune taxi fare service provides transparent and affordable pricing for passengers traveling between Navi Mumbai and Pune. Travelers can choose from a variety of vehicles including sedan, Ertiga, and Innova depending on their comfort requirements and group size. The service ensures smooth expressway travel with experienced drivers who prioritize safety and punctuality. Pickup services are available from residential areas, hotels, offices, and railway stations throughout Navi Mumbai. Ideal for business travelers, tourists, and families planning intercity travel. Clear pricing details help passengers plan their journey without hidden charges."
},
{
name: "Navi Mumbai to Pune One Way Taxi",
description: "Navi Mumbai to Pune one way taxi service provides economical single-trip transportation without return charges. This service is perfect for travelers who only need a drop from Navi Mumbai to Pune. Comfortable vehicles including sedan, Ertiga, and Innova ensure smooth expressway journeys. Professional drivers provide safe driving and timely pickups from residential complexes, offices, and hotels across Navi Mumbai. Ideal for business trips, airport transfers, and personal travel. Flexible one-way booking options allow passengers to schedule rides easily while enjoying comfortable highway travel."
},
{
name: "Navi Mumbai to Pune Innova Taxi",
description: "Navi Mumbai to Pune Innova taxi service offers premium SUV transportation with spacious interiors and comfortable seating. The Toyota Innova and Innova Crysta vehicles are ideal for families, corporate travelers, and small groups traveling between Navi Mumbai and Pune. Professional drivers ensure safe expressway travel and punctual pickup services from homes, offices, and railway stations. The spacious luggage capacity makes this vehicle ideal for airport transfers and long-distance trips. Comfortable air-conditioned interiors ensure a relaxed journey across the highway."
},
{
name: "Navi Mumbai to Pune Ertiga Taxi",
description: "Navi Mumbai to Pune Ertiga taxi service provides comfortable 7-seater SUV transportation for passengers traveling between Navi Mumbai and Pune. The Ertiga vehicle is suitable for families and small groups seeking economical yet spacious travel. Professional drivers ensure safe expressway driving and timely pickup services from residential areas, offices, and hotels across Navi Mumbai. Comfortable seating and smooth highway performance make it a popular choice for intercity journeys. Flexible booking options allow passengers to reserve rides easily for business travel or family trips."
},
{
name: "Navi Mumbai to Pune Sedan Cab",
description: "Navi Mumbai to Pune sedan cab service offers economical transportation using vehicles like Swift Dzire, Etios, and Xcent. These comfortable sedans are ideal for individuals, couples, and small families traveling between Navi Mumbai and Pune. Professional drivers ensure safe expressway travel and punctual pickups from homes, hotels, offices, and railway stations across Navi Mumbai. Air-conditioned interiors provide comfortable travel during long journeys. Affordable pricing makes sedan cabs one of the most popular options for intercity travel."
},
{
name: "Navi Mumbai to Pune Round Trip Cab",
description: "Navi Mumbai to Pune round trip cab service provides convenient two-way transportation for travelers planning return journeys between the two cities. Comfortable vehicles including sedan, Ertiga, and Innova ensure smooth expressway travel for both onward and return trips. Professional drivers provide punctual pickup services and safe driving throughout the journey. Ideal for corporate meetings, family visits, and tourism travel. Flexible round-trip booking options allow passengers to travel comfortably with planned return schedules."
},
{
name: "Navi Mumbai to Hinjewadi Cab",
description: "Navi Mumbai to Hinjewadi cab service provides reliable transportation between Navi Mumbai and Pune’s major IT hub Hinjewadi. This service is ideal for professionals traveling for corporate meetings, office visits, and business trips. Comfortable vehicles ensure smooth expressway travel while experienced drivers provide safe and timely pickup services. Pickup services are available from residential areas, offices, and hotels across Navi Mumbai. Air-conditioned vehicles ensure comfortable travel during long-distance journeys."
},
{
name: "Navi Mumbai to Pune Cab",
description: "Navi Mumbai to Pune cab service offers dependable intercity transportation with comfortable vehicles and professional drivers. Travelers can choose from sedan, Ertiga, and Innova vehicles depending on their travel needs. The service provides smooth travel via the Mumbai–Pune Expressway with safe driving and punctual pickups. Ideal for business travel, tourism visits, and family trips. Flexible booking options allow passengers to schedule rides easily and enjoy convenient pickup and drop services."
},
{
name: "Pune to Navi Mumbai Cab",
description: "Pune to Navi Mumbai cab service offers reliable return transportation between Pune city and Navi Mumbai. Comfortable vehicles ensure smooth expressway travel while professional drivers provide safe driving and punctual pickups. The service is suitable for airport transfers, business travel, and family trips. Pickup services are available from homes, offices, railway stations, and hotels across Pune. Air-conditioned vehicles ensure comfortable long-distance travel."
},
{
name: "Cab Service in Navi Mumbai",
description: "Cab service in Navi Mumbai provides reliable transportation for city rides, airport transfers, and outstation journeys. Comfortable vehicles including sedan, Ertiga, and Innova are available for different travel needs. Professional drivers ensure punctual pickup services from homes, offices, hotels, and railway stations across Navi Mumbai. Ideal for daily commuting, corporate travel, and long-distance trips. Flexible booking options make it easy for passengers to reserve rides anytime."
},
{
name: "Cab Hire in Navi Mumbai",
description: "Cab hire in Navi Mumbai offers convenient vehicle rental with drivers for local and outstation travel. Travelers can hire comfortable vehicles such as sedan, Ertiga, and Innova for city rides, airport transfers, and highway journeys. Professional drivers ensure safe driving and punctual pickup services across Navi Mumbai. Ideal for business meetings, tourism travel, and family trips. Flexible hire options allow passengers to book vehicles for single trips or full-day travel."
},
{
name: "Cab Service in Airoli",
description: "Cab service in Airoli provides dependable transportation for passengers traveling locally within Navi Mumbai or planning outstation journeys to Pune and other cities. Comfortable vehicles and experienced drivers ensure safe travel. Pickup services are available from homes, offices, and hotels throughout Airoli. Ideal for airport transfers, business travel, and family trips."
},
{
name: "Cabs Navi Mumbai",
description: "Cabs in Navi Mumbai provide reliable transportation for city travel, airport transfers, and outstation journeys. Passengers can choose from a range of vehicles including sedan, Ertiga, and Innova depending on their travel needs. Professional drivers ensure safe driving and punctual pickup services. Comfortable air-conditioned vehicles ensure pleasant journeys across Navi Mumbai and nearby destinations."
},
{
name: "Kharghar Taxi Service",
description: "Kharghar taxi service offers reliable transportation for passengers traveling within Navi Mumbai or planning outstation trips to Pune and nearby cities. Comfortable vehicles and professional drivers ensure safe travel experiences. Pickup services are available from homes, offices, hotels, and railway stations across Kharghar. Ideal for business travel, airport transfers, and family journeys."
},
{
name: "Navi Mumbai Taxi Service",
description: "Navi Mumbai taxi service provides dependable transportation across the city and nearby destinations such as Pune, Lonavala, and Nashik. Comfortable vehicles ensure safe and smooth travel while professional drivers provide punctual pickup services. Ideal for daily commuting, airport transfers, and intercity travel."
},
{
name: "Taxi Service in Vashi Navi Mumbai",
description: "Taxi service in Vashi Navi Mumbai provides convenient transportation for city rides and outstation journeys. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth travel experiences. Professional drivers provide safe driving and punctual pickups from homes, offices, and hotels across Vashi."
},
{
name: "Innova Crysta on Rent in Navi Mumbai",
description: "Innova Crysta on rent in Navi Mumbai offers premium SUV transportation with spacious seating and luxurious interiors. This vehicle is ideal for families, corporate travelers, and group travel. Comfortable seating and powerful highway performance ensure relaxed journeys across long distances."
},
{
name: "Ertiga on Rent in Navi Mumbai",
description: "Ertiga on rent in Navi Mumbai provides comfortable 7-seater SUV transportation suitable for families and small groups traveling within the city or planning outstation trips. Spacious seating and economical pricing make it a popular travel option."
},
{
name: "Outstation Cabs in Navi Mumbai",
description: "Outstation cabs in Navi Mumbai provide reliable long-distance transportation from Navi Mumbai to cities such as Pune, Nashik, Lonavala, and Shirdi. Comfortable vehicles and experienced drivers ensure safe highway journeys. Flexible booking options allow passengers to plan trips conveniently."
},
{
name: "Navi Mumbai to Pune Cab Service",
description: "Navi Mumbai to Pune cab service provides dependable intercity transportation between the two cities with comfortable vehicles and professional drivers. Pickup services are available from residential areas, offices, hotels, and railway stations across Navi Mumbai. Ideal for business trips, tourism travel, and family journeys."
},
{
name: "Navi Mumbai to Pune Taxi Service",
description: "Navi Mumbai to Pune taxi service offers convenient travel options for passengers heading between Navi Mumbai and Pune city. Comfortable vehicles and experienced drivers ensure smooth highway travel. Flexible booking options allow passengers to reserve taxis easily for safe and comfortable intercity journeys."
}
],

tableData: [
["Navi Mumbai to Pune Taxi","Navi Mumbai to Pune Taxi Fare"],
["Navi Mumbai to Pune One Way Taxi","Navi Mumbai to Pune Innova Taxi"],
["Navi Mumbai to Pune Ertiga Taxi","Navi Mumbai to Pune Sedan Cab"],
["Navi Mumbai to Pune Round Trip Cab","Navi Mumbai to Hinjewadi Cab"],
["Navi Mumbai to Pune Cab","Pune to Navi Mumbai Cab"],
["Cab Service in Navi Mumbai","Cab Hire in Navi Mumbai"],
["Cab Service in Airoli","Cabs Navi Mumbai"],
["Kharghar Taxi Service","Navi Mumbai Taxi Service"],
["Taxi Service in Vashi Navi Mumbai","Innova Crysta on Rent in Navi Mumbai"],
["Ertiga on Rent in Navi Mumbai","Outstation Cabs in Navi Mumbai"],
["Navi Mumbai to Pune Cab Service","Navi Mumbai to Pune Taxi Service"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Navi Mumbai to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Navi Mumbai to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Navi Mumbai to Pune cab service operates 24 hours a day. Whether you need an early morning ride, airport transfer, or late night travel, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Navi Mumbai to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Navi Mumbai including Vashi, Nerul, Belapur, Kharghar, Panvel, and Airoli."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Navi Mumbai to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Navi Mumbai to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Navi Mumbai to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Navi Mumbai from Pune?", answer: "The road distance between Navi Mumbai and Pune is approximately 120–130 km and the journey usually takes about 2.5 to 3 hours depending on traffic." },
  { question: "Is Navi Mumbai to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Navi Mumbai to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Navi Mumbai to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Navi Mumbai and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential areas across Navi Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Navi Mumbai to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service anywhere in Pune?", answer: "Yes, Velocity Cabs provides drop services across Pune including Baner, Hinjewadi, Wakad, Kharadi, Hadapsar, and Pimpri Chinchwad." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshmukh",
    feedback:
      "A very smooth and comfortable journey from Navi Mumbai to Pune. The cab was punctual, well-maintained, and the ride felt relaxed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "The Navi Mumbai to Pune cab service was reliable and well-organized. The vehicle was clean, the drive was steady, and the entire trip felt safe and hassle-free.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Pune Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Navi Mumbai to Pune cab service with affordable fares and professional drivers. Book one way and round trip taxis including Innova, Innova Crysta, Ertiga, and Sedan cabs for airport transfers, city-to-city travel, and corporate trips. Enjoy safe, comfortable, and punctual rides with easy online booking from Navi Mumbai to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai to Pune cab with Velocity Cabs. Affordable one way & round trip taxis including Innova, Innova Crysta, Ertiga & Sedan for airport transfers, city-to-city travel & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitopunecab;